import "./index.css";
import Textarea from "../../../layout/Textarea/Textarea";
import {useEdits} from "../../../contexts/edits";
import {useSetting} from "../../../contexts/setting";
import {useImages} from "../../../contexts/images";
import BgTransformer from "../../../layout/BgTransformer";
import adsAssets from "../../../data/ads-assets.json";

/**
 * SquareDevecoAds — 1080×1080 square YouTube Community / generic-square ad
 * for the JB DevEco survey. Figma source: 1429:891.
 *
 * Card sits at template y=+64.5 (vertically centered, but smaller than the
 * frame so there's letterboxing top + bottom). Photo composited into the
 * card with overflow clipped at card boundaries.
 */
const SquareDevecoAds = ({id, zoom}) => {
  const {channel, product, type, bgOption, locked} = useSetting();
  const {customBgs} = useImages();
  const isLocked = locked.some((x) => x === id);
  const customBgUrl = (isLocked ? customBgs[id] : undefined) || customBgs.main || null;
  const {titles, subtitles} = useEdits();
  const title = titles[id] || titles.main;
  const subtitle = subtitles[id] || subtitles.main;

  const bgIdx = bgOption || 1;
  const assetKey = `${channel.value}/${product.value}/${type.value}/${bgIdx}/${id}`;
  const bgUrl = adsAssets[assetKey]?.url;

  return (
    <div id={id} className={`template ${type.value} tpl-card`} style={{"--zoom-level": zoom}}>
      <div className="tpl-card__inner">
        {customBgUrl || bgUrl ? <BgTransformer src={customBgUrl || bgUrl} id={id} /> : null}
        <div className="tpl-bubble">
          <h2 className="subtitle">
            <Textarea id={id} text={subtitle} />
          </h2>
          {/* Tail path lifted verbatim from Figma node 1429:898 (Vector 1).
           * Gradient aligned to bubble's coord frame via userSpaceOnUse so
           * it continues seamlessly across rect+tail. */}
          <svg
            className="tpl-bubble__tail"
            viewBox="0 0 49 56"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <defs>
              <linearGradient
                id="SquareDevecoAds-tail-gradient"
                gradientUnits="userSpaceOnUse"
                x1="12.471"
                y1="-93.929"
                x2="466.725"
                y2="45.343"
              >
                <stop offset="0" stopColor="#211104" />
                <stop offset="1" stopColor="#472407" />
              </linearGradient>
            </defs>
            <path
              d="M0 56.0001C0 56.0001 12.6525 22.0252 12.6525 0L48.9708 26.477C30.9288 47.7993 0 56.0001 0 56.0001Z"
              fill="url(#SquareDevecoAds-tail-gradient)"
            />
          </svg>
        </div>
        <h1 className="title">
          <Textarea id={id} text={title} />
        </h1>
      </div>
    </div>
  );
};

export default SquareDevecoAds;
